import React, { useEffect, useState } from "react";
import { getDataTables, getDataTableRows } from "../utilities/genesysCloudUtils";
import "../App.css";
import { DataTableRows } from "./DataTableRows";

export function DataTables({
  checkedDivisions,
  setPageCount,
  pageNumber,
  setPageNumber,
  setTabName,
  opts,
  setOpts,
  setIsVisible
}) {
  const [dataTables, setDataTables] = useState([]);
  const [collapse, setCollapse] = useState();

  useEffect(() => {
    setPageNumber(1);
    setTabName("data-tables-tab");
    setOpts({})
    setIsVisible({ divisions: true, object: false, applyButton: false })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  console.log(collapse)

  useEffect(() => {
    getDataTables(checkedDivisions).then((data) => {
      setDataTables(data.entities.sort((a, b) => a.name.localeCompare(b.name)));
      setPageCount(data.pageCount);
    });
  }, [checkedDivisions]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleCollapseChange = (e, dataTableId) => {
    setCollapse(e.target.checked);
    console.log(dataTableId)
    if (e.target.checked) {
      getDataTableRows(dataTableId).then((data) => {
        console.log("Data Table Rows:", data);
        setDataTables((prevDataTables) =>
          prevDataTables.map((dataTable) =>
            dataTable.id === dataTableId
              ? { ...dataTable, rows: data.entities }
              : dataTable
          )
        );
      });
      console.log(dataTables)
    }
  }

  return (
    <>
      {dataTables ? (
        // TODO: Update each data table
        <table className="table">
          <thead>
            <tr>
              <th>Count</th>
              <th>Data Table Name</th>
              <th>Data Table Id</th>
            </tr>
          </thead>
          <tbody>
            {dataTables.map((dataTable, index) => {
              return (
                <tr key={dataTable.id}>
                  <th className="index">{index + 1}</th>
                  <td>
                    <div className="collapse collapse-arrow">
                      <input type="checkbox"
                        onChange={(e) => handleCollapseChange(e, dataTable.id)}
                      />
                      <div className="collapse-title">{dataTable.name}</div>
                      <div className="collapse-content">
                        <DataTableRows
                          dataTable={dataTable}
                          collapse={collapse}
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <kbd className="kbd">{dataTable.id}</kbd>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <h1>Loading...</h1>
      )}
    </>
  );
}
